module.exports = __webpack_public_path__ + "img/logotttn.05c2a17f.png";